import { type Dtos, type FileId, type SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import {
	balanceSheetsQueryKey,
	financialExtractionsQueryKey,
	financialPeriodsQueryKey,
	incomeStatementsQueryKey,
} from "../../financials/financials.keys";

export function useExtractFinancialFile(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async (fileId: FileId) => {
			const body: Dtos.FinancialExtraction.Create.Request = { fileId };
			return post<Dtos.FinancialExtraction.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/financial-extractions`,
				body,
			);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: financialExtractionsQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: balanceSheetsQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: incomeStatementsQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: financialPeriodsQueryKey(accountId) }),
			]);
		},
	});

	return {
		extractFinancialFile: mutation.mutate,
		extractFinancialFilePending: mutation.isPending,
		extractFinancialFileError: mutation.error,
		dismissExtractFinancialFileError: () => {
			mutation.reset();
		},
	};
}
